module.exports = __webpack_public_path__ + "static/media/wn_5.172676db.jpg";